<p
  class="base-helper-text"
  [ngClass]="classNames()"
  [class.remove-padding]="removePadding"
>
  <ng-content></ng-content>
</p>
